'use client';

import { FC, PropsWithChildren } from 'react';
import { ContextLibraryProvider } from './_context/ContextLibraryContext';

const ContextLibraryLayout: FC<PropsWithChildren<unknown>> = ({ children }) => {
  return <ContextLibraryProvider>{children}</ContextLibraryProvider>;
};

export default ContextLibraryLayout;
